module.exports = __webpack_public_path__ + "static/media/RecomendaFinados.2bb091b2.jpg";